(function () {
  document.querySelectorAll('.contact-us-custom').forEach(function (section) {
    var sectionId = section.id.replace('section-', '');
    var formWrapper = document.getElementById('contact-form-' + sectionId);
    var successEl = document.getElementById('contact-success-' + sectionId);

    if (!formWrapper) return;

    var form = formWrapper.querySelector('form');
    if (!form) return;

    // Create hidden iframe for form submission
    var iframeName = 'contact-iframe-' + sectionId;
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    // Set form target to hidden iframe
    form.setAttribute('target', iframeName);

    // Listen for iframe load (form submitted successfully)
    var submitted = false;
    form.addEventListener('submit', function () {
      submitted = true;
      var btn = form.querySelector('.contact-us-custom__submit-btn');
      btn.textContent = '...';
      btn.disabled = true;
    });

    iframe.addEventListener('load', function () {
      if (!submitted) return;
      formWrapper.style.display = 'none';
      if (successEl) {
        successEl.style.display = 'block';
      }
    });
  });
})();
